import { createSlice } from "@reduxjs/toolkit";
import { SearchFieldState } from "../types";

const initialState: SearchFieldState = {
  globalSearchText: "",
  shouldSubmit: false,
  submitImmediately: false,
};

const searchFieldSlice = createSlice({
  name: "searchField",
  initialState,
  reducers: {
    setGlobalSearchText(state, action) {
      state.globalSearchText = action.payload;
    },
    setTextAndSubmit: (state, action) => {
      state.globalSearchText = action.payload;
      state.shouldSubmit = true;
      state.submitImmediately = false;
    },
    // Same as setTextAndSubmit, but skips the typewriter animation. Used by
    // voice mode, where the animation is invisible latency on top of an
    // already-slow turn.
    setTextAndSubmitImmediately: (state, action) => {
      state.globalSearchText = action.payload;
      state.shouldSubmit = true;
      state.submitImmediately = true;
    },
    clearSubmitFlag: (state) => {
      state.globalSearchText = "";
      state.shouldSubmit = false;
      state.submitImmediately = false;
    },
  },
});

export default searchFieldSlice.reducer;
export const searchFieldActions = searchFieldSlice.actions;
